import React from 'react';

import CardBox from 'RLX/Forms/CardBox';
import ListField from 'RLX/Forms/ListField';

class CardList extends ListField {
  constructor (props) {
    super(props);
    this.renderListItem = this.renderListItem.bind(this);
  }

  getClassName () {
    return 'CardList';
  }

  renderListItem (card, index, cardCount) {
    const { onItemUpdate, onItemDelete, onItemReorder } = this;
    const changeHandler = (newValue) => onItemUpdate(newValue, index);
    const deleteHandler = () => onItemDelete(index);
    return (
      <CardBox
        card={card}
        key={index}
        count={cardCount}
        index={index}
        horizontal={true}
        onChange={changeHandler}
        onDelete={deleteHandler}
        onReorder={onItemReorder}
      />
    );
  }

  shouldPromptBeforeDeleting (card = {}) {
    const { title, image, imagePosition, url, content } = card;
    return (title && title.length)
      || (image && image.length)
      || (imagePosition && imagePosition.length)
      || (url && url.length)
      || (content && content.length);
  }

  getItemDefaults () {
    return {
      title: null,
      image: null,
      imagePosition: null,
      url: null,
      content: null
    }
  }
};

export default CardList;



// WEBPACK FOOTER //
// ./client/RLX/Forms/CardList/CardList.jsx